<script setup lang="ts">
const items = [
  'Tarif kurir akurat & real-time dari 18+ partner ekspedisi',
  'Opsi pembayaran COD dengan pencairan dana di hari yang sama',
  'Jadwalkan pick up dari rumah atau antar paket ke agen terdekat',
  'Cetak label pengiriman otomatis & kelola semua pengiriman di satu dashboard',
  'Tracking paket real-time & dukungan Customer Service 24/7'
]
</script>

<template>
  <UiSectionWrapper
    image-class="order-first lg:order-first"
    title="Keuntungan Menggunakan Plugin Shopify"
    hero-image="/images/plugin-shopify-banner-2.webp"
    :items="items"
    class="py-12"
    :with-action="false"
  />
</template>
